import { Link } from "react-router-dom";
import { Box, Button, Typography } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

const MyAssessmentCard = ({ assessment }) => {
  const { assessmentStatus = "purchase", reportGenerated360 } = assessment;

  return (
    <div className="assessmentCard">
      <div
        style={{ display: "flex", alignItems: "center", flex: 1, minWidth: 0 }}
      >
        <div className="assessmentCardIcon">
          <img
            className="assesmentMainImage"
            alt="Assessment Logo"
            src={assessment.mainImage}
          />
        </div>
        <Typography
          component="div"
          variant="h5"
          color="secondary"
          fontWeight={600}
          sx={{
            marginLeft: "30px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            flex: 1,
            minWidth: 0,
          }}
          dangerouslySetInnerHTML={{ __html: assessment.name }}
        />
      </div>
      <Box display="flex">
        {assessmentStatus === "view_results" && (
          <>
            {assessment.is360 && reportGenerated360 && (
              <Button
                component={Link}
                to={`/${assessment?.slug}/groups/report`}
                className="assessmentCardButton"
                variant="contained"
                startIcon={<ArrowForwardIcon className="invertIcon" />}
              >
                View Results
              </Button>
            )}
            {assessment.is360 && !reportGenerated360 && (
              <Button
                disabled
                className="assessmentCardButton"
                variant="contained"
                sx={{ opacity: 0.7 }}
              >
                Processing
              </Button>
            )}
            {!assessment.is360 && (
              <Button
                component={Link}
                to={`/${assessment?.slug}/report`}
                className="assessmentCardButton"
                variant="contained"
                startIcon={<ArrowForwardIcon className="invertIcon" />}
              >
                View Results
              </Button>
            )}
          </>
        )}
        {assessmentStatus === "access" && (
          <Button
            component={Link}
            to={`/${assessment?.slug}`}
            className="assessmentCardButton"
            variant="contained"
            startIcon={<ArrowForwardIcon className="invertIcon" />}
          >
            Access
          </Button>
        )}
        {assessmentStatus === "purchase" && (
          <Button
            href={assessment.externalURL || undefined}
            disabled={!assessment.externalURL}
            className="assessmentCardButton borderButtonGreen"
            variant="contained"
            sx={{ marginRight: "30px" }}
            title={!assessment.externalURL ? "Purchase URL not available" : ""}
          >
            Purchase
          </Button>
        )}
      </Box>
    </div>
  );
};

export default MyAssessmentCard;
